var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardJcb(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6186 12.995H23.6419C23.6997 12.995 23.8346 12.9758 23.8924 12.9758C24.2778 12.8987 24.6054 12.5518 24.6054 12.0701C24.6054 11.6076 24.2778 11.2607 23.8924 11.1644C23.8346 11.1451 23.719 11.1451 23.6419 11.1451H21.6186V12.995Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4107 0.219032C21.4837 0.219032 19.9036 1.7799 19.9036 3.72617V7.3682H24.8559C24.9716 7.3682 25.1065 7.3682 25.2028 7.38747C26.3205 7.44528 27.1491 8.02338 27.1491 9.02541C27.1491 9.81548 26.5902 10.4899 25.5497 10.6248V10.6634C26.6866 10.7404 27.5537 11.3764 27.5537 12.3591C27.5537 13.419 26.5902 14.1127 25.3184 14.1127H19.8843V21.2426H25.0294C26.9564 21.2426 28.5365 19.6817 28.5365 17.7354V0.219032H23.4107Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3549 9.25665C24.3549 8.79417 24.0273 8.48585 23.6419 8.42804C23.6034 8.42804 23.507 8.40877 23.4492 8.40877H21.6186V10.1045H23.4492C23.507 10.1045 23.6227 10.1045 23.6419 10.0853C24.0273 10.0274 24.3549 9.71913 24.3549 9.25665Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02509 0.219032C2.0981 0.219032 0.517958 1.7799 0.517958 3.72617V12.3784C1.50073 12.8601 2.52204 13.1685 3.54334 13.1685C4.75735 13.1685 5.41253 12.4362 5.41253 11.4342V7.34892H8.41865V11.4149C8.41865 12.995 7.43588 14.2861 4.10217 14.2861C2.07883 14.2861 0.498688 13.8429 0.498688 13.8429V21.2233H5.64377C7.57077 21.2233 9.15091 19.6624 9.15091 17.7162V0.219032H4.02509Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7179 0.219032C11.7909 0.219032 10.2108 1.7799 10.2108 3.72617V8.31242C11.0972 7.56089 12.6388 7.07915 15.1246 7.19477C16.4542 7.25258 17.8802 7.61871 17.8802 7.61871V9.10249C17.1672 8.73636 16.3193 8.40877 15.2209 8.33169C13.3325 8.1968 12.1956 9.12176 12.1956 10.7404C12.1956 12.3784 13.3325 13.3033 15.2209 13.1492C16.3193 13.0721 17.1672 12.7253 17.8802 12.3784V13.8622C17.8802 13.8622 16.4735 14.2283 15.1246 14.2861C12.6388 14.4017 11.0972 13.92 10.2108 13.1685V21.2619H15.3558C17.2828 21.2619 18.863 19.701 18.863 17.7547V0.219032H13.7179Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.9003,
    y1: 12.0724,
    x2: 28.5598,
    y2: 12.0724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.9001,
    y1: 10.7224,
    x2: 28.5602,
    y2: 10.7224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 19.9001,
    y1: 9.25424,
    x2: 28.5599,
    y2: 9.25424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 0.513877,
    y1: 10.7224,
    x2: 9.30736,
    y2: 10.7224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 10.1609,
    y1: 10.7224,
    x2: 18.7014,
    y2: 10.7224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardJcb);
export default __webpack_public_path__ + "static/media/icon-card-jcb.38382445.svg";
export { ForwardRef as ReactComponent };